import { useRouter } from "next/router";
import { useContext, useState } from "react";
import { useSelector } from "react-redux";
import {
  useGetProfileDetails,
  useLocation,
  useWithAuth,
} from "../../../../hoc";
import { Context } from "services";

export const usePLCommonStates = ({
  defaultLocation,
  cities,
}: {
  defaultLocation: any;
  cities: any;
}) => {
  const router = useRouter();

  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [acknowledgementOpen, setAcknowledgementOpen] = useState(false);
  const [acknowledgmentErrorMessage, setAcknowledgmentErrorMessage] =
    useState("");

  const isLoggedIn = useSelector((state: any) => state.auth.accessToken);

  const { city } = useLocation(defaultLocation, cities);
  const { searchForm }: any = useContext(Context);

  const { withAuth } = useWithAuth({
    openAuthModel: () => setAuthModalOpen(true),
  });

  const user = useGetProfileDetails();

  return {
    router,
    isFilterOpen,
    setIsFilterOpen,
    isLoggedIn,
    authModalOpen,
    setAuthModalOpen,
    acknowledgementOpen,
    setAcknowledgementOpen,
    acknowledgmentErrorMessage,
    setAcknowledgmentErrorMessage,
    city,
    searchForm,
    withAuth,
    user,
  };
};
